import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {FranchiseDashboardComponent} from './franchise-dashboard/franchise-dashboard.component';
import { FranchiseUserComponent } from './franchise-user/franchise-user.component';
import {CallAlertComponent } from './call-alert/call-alert.component';
import { AddReceiptComponent } from '../user/add-receipt/add-receipt.component';
import { ViewReceiptsComponent } from '../user/view-receipts/view-receipts.component';
import { ViewServicesComponent } from './view-services/view-services.component';
import { FranchseUserDetailsComponent } from './franchse-user-details/franchse-user-details.component';
import { CallAlertListComponent } from './call-alert-list/call-alert-list.component';
import { AddPropertyComponent } from './add-property/add-property.component';
import { ViewPropertyComponent } from './view-property/view-property.component';
import { AreaAlertListComponent } from './area-alert-list/area-alert-list.component';
import { ViewTpListComponent } from './view-tp-list/view-tp-list.component';
import { AddTpServiceComponent } from './add-tp-service/add-tp-service.component';
import { AddEppServiceComponent } from './add-epp-service/add-epp-service.component';
import { ViewEppListComponent } from './view-epp-list/view-epp-list.component';
import { AddNewEppComponent } from './add-new-epp/add-new-epp.component';
import { EditEppComponent } from './edit-epp/edit-epp.component';
import { AddAreaAlertComponent } from './add-area-alert/add-area-alert.component';
import { ViewAreaSmsAlertComponent } from './view-area-sms-alert/view-area-sms-alert.component';
import { ViewPpSmsAlertComponent } from './view-pp-sms-alert/view-pp-sms-alert.component';
import { ViewEmailPpAlertComponent } from './view-email-pp-alert/view-email-pp-alert.component';
import { AuctionAlertComponent } from './auction-alert/auction-alert.component';
import { ViewEmailEppAlertComponent } from './view-email-epp-alert/view-email-epp-alert.component';
import { ViewEmailTpAlertComponent } from './view-email-tp-alert/view-email-tp-alert.component';
import { AddAuctionAlertComponent } from './add-auction-alert/add-auction-alert.component';
import { EditAuctionAlertComponent } from './edit-auction-alert/edit-auction-alert.component';
import { AuctionEmailLogComponent } from './auction-email-log/auction-email-log.component';
import { AreaEmailLogComponent } from './area-email-log/area-email-log.component';
import { SubscriptionPlanComponent } from '../user/subscription-plan/subscription-plan.component';
import { ViewPlanComponent } from './view-plan/view-plan.component';
import { UserDistrictComponent } from './user-district/user-district.component';
import { AddUserDistrictComponent } from './add-user-district/add-user-district.component';
import { LrsRequestComponent } from './lrs-request/lrs-request.component';
import { ViewLrsDocumentComponent } from './view-lrs-document/view-lrs-document.component';
import { LoginReportComponent } from './login-report/login-report.component';
import { WhatsappReportComponent } from './whatsapp-report/whatsapp-report.component';
import { LandRecordOrdersComponent } from '../user/land-record-orders/land-record-orders.component';
import { MatIconModule } from '@angular/material/icon';

import { DailyCallAlertReportComponent } from './daily-call-alert-report/daily-call-alert-report.component';
import { AddAuctionComponent } from './add-auction/add-auction.component';
import { AddServicesComponent } from './add-services/add-services.component';

const routes: Routes = [
  {
    path: '',redirectTo:'users-users',pathMatch:'full'
  },
  {
    path: 'users-dashboard',
    component: FranchiseDashboardComponent,
  },
  {
    path:'view-property',
    component:ViewPropertyComponent
  },
  {
    path:'pp-email-alert',
    component:ViewEmailPpAlertComponent
  },
  {
    path: 'users-users-details/addAreaAlert',
    component: AddAreaAlertComponent,
  },
  {
    path:'login-report',
    component:LoginReportComponent
  },
  {
    path:'whatsapp-report',
    component:WhatsappReportComponent
  },
  {
    path: 'land-record-orders',
    component: LandRecordOrdersComponent
  },
  {
    path:'addauction',
    component:AddAuctionComponent
  },
  {
    path:'users-users-details/editAuction/:UsersubscriptionMainID',
    component:AddAuctionComponent
  },
  {
    path: 'users-users-details/addAreaAlert/:type/:id',
    component: AddAreaAlertComponent,
  },
  {
    path:'lrs-user-details',
    component: LrsRequestComponent
  },
  {
    path:'view-document/:UserID',
    component:ViewLrsDocumentComponent
  },
  {
    path:'area-alert-list',
    component:AreaAlertListComponent
  },
  {
    path:'add-new-epp',
    component:AddEppServiceComponent
  },
  {
    path:'add-epp',
    component:AddNewEppComponent
  },
  {
    path:'tp-email-alert',
    component:ViewEmailTpAlertComponent
  },
  {
    path:'area-email-alert',
    component:AreaEmailLogComponent
  },
  {
    path:'auction-email-alert',
    component:AuctionEmailLogComponent
  },
  {
    path:'edit-epp',
    component:EditEppComponent
  },
  {
    path:'view-epp',
    component:ViewEppListComponent
  },
  {
    path:'auctionAlert',
    component:AuctionAlertComponent
  },
  {
    path:'epp-email-alert',
    component: ViewEmailEppAlertComponent
  },
  {
    path:'pp-sms-alert',
    component:ViewPpSmsAlertComponent
  },
  {
    path:'area-sms-alert',
    component:ViewAreaSmsAlertComponent
  },
  {
    path:'view-tp-list',
    component:ViewTpListComponent
  },
  {
    path:'tp-service',
    component:AddTpServiceComponent
  },
  {
    path:'property',
    component:AddPropertyComponent
  },
  {
    path: 'users-users',
    component: FranchiseUserComponent,
  },
  {
    path:'userDistrcit',
    component: UserDistrictComponent
  },
  {
    path:'add-user-district',
    component:AddUserDistrictComponent
  },
  {
    path:'users-callAlertList',
    component: CallAlertListComponent
  },
  {
    path:'daily-call-alert',
    component:DailyCallAlertReportComponent
  },
  {
    path: 'users-users-details',
    component: FranchseUserDetailsComponent,
  },
  {
    path:'subscriptionplan',
    component:ViewPlanComponent
  },
  {
    path: 'users-users-details/call-alert',
    component: CallAlertComponent,
  },
  {
    path: 'users-users-details/receipts',
    component: ViewReceiptsComponent,
  },
  {
    path: 'users-users-details/services-interest',
    component: ViewServicesComponent,
  },
  {
    path: 'users-users-details/receipts/add',
    component: AddReceiptComponent,
  },
  {
    path: 'users-users-details/services-interest/add',
    component: AddServicesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FranchiseRoutingModule {}
